export default __webpack_public_path__ + "static/hair-skin-nails-9ce0066a94a223f6321d6e980e0a30c9.png";